export const getProtocols = (url: string): string[] => {
  const index = url.indexOf("://");

  return url.substring(0, index).split("+").filter(Boolean);
}

export const cleanUrl = (url: string): string => (
  getProtocols(url).length ? url : `https://${url}`
)
